/**
 * @file
 */

import pauseAnimation from './pauseAnimation.js'
import mainNavigation from './mainNavigation.js'
import dcnAccordion from './dcnAccordion.js'
import dcnPieChart from './dcnPieChart.js'
import basicTables from './basicTables.js'
import colorThiefHero from './colorThiefHero.js'

((Drupal, once) => {
  pauseAnimation(Drupal, once)
  mainNavigation(Drupal, once)
  dcnAccordion(Drupal, once)
  dcnPieChart(Drupal, once)
  basicTables(Drupal, once)
  colorThiefHero(Drupal, once)
})(Drupal, once)
